<div class="container-fluid">
    <span class="iso-header">
        {{ 'bikeshop.rentals.service_indicators_config.service_indicator_config' | translate }}
    </span>

    <div style="margin-top: 16px;"></div>
    <div class="info-container">
        <div class="row">
            <div class="col-md-12 label header">{{'bikeshop.rentals.service_indicators_config.configuration' |
                translate}}</div>
        </div>

        <div class="row mb-3 margin-top-8">
            <div class="col-md-6 label" [ngClass]="{'red': !serviceIndicatorConfig.serviceIndicatorName}">
                {{'bikeshop.rentals.service_indicators_config.service_indicator_name' | translate}}:
            </div>
            <div class="col-md-6">
                <input pInputText [(ngModel)]="serviceIndicatorConfig.serviceIndicatorName">
            </div>
        </div>

        <div class="row" *ngIf="serviceIndicatorConfig.id > 0">
            <div class="col-md-6 label">{{'bikeshop.rentals.service_indicators_config.service_indicator_status' |
                translate}}:</div>
            <div class="col-md-1 flex"><p-inputSwitch [(ngModel)]="serviceIndicatorConfig.isActive"></p-inputSwitch>
            </div>
        </div>

        <div class="row mb-3 margin-top-8" *ngIf="serviceIndicatorConfig.isActive">
            <div class="col-md-6 label">
                {{'bikeshop.rentals.service_indicators_config.configuration_mode' | translate}}:
            </div>
            <div class="col-md-6">
                <p-dropdown [options]="serviceIndicatorModes" [(ngModel)]="serviceIndicatorConfig.mode">
                </p-dropdown>
            </div>
        </div>

        <div class="row" *ngIf="serviceIndicatorConfig.isActive">
            <div class="col-md-6 label">
                <span>{{'bikeshop.rentals.service_indicators_config.default_indicator' | translate}}</span>
                <span class="fa fa-question"
                    pTooltip="{{'bikeshop.rentals.service_indicators_config.default_indicator_description' | translate}}"></span>
            </div>
            <div class="col-md-1 flex"><p-inputSwitch
                    [(ngModel)]="serviceIndicatorConfig.defaultIndicator"></p-inputSwitch>
            </div>
        </div>

        <div class="row mb-3 margin-top-8" *ngIf="serviceIndicatorConfig.isActive">
            <div class="col-md-6 label">
                <span>{{'bikeshop.rentals.service_indicators_config.linked_product_categories' | translate}}:</span>
                <span class="fa fa-question"
                    pTooltip="{{'bikeshop.rentals.service_indicators_config.select_linked_product_categories_description' | translate}}"></span>
            </div>
            <div class="col-md-6">
                <p-multiSelect [options]="productCategories" optionLabel="categoryName" optionValue="categoryID" [disabled]="loadingProductCategories"
                    [(ngModel)]="serviceIndicatorConfig.linkedCategories"
                    [filter]="false" [showHeader]="false" [showToggleAll]="false" [showHeader]="false" [resetFilterOnHide]="true"
                    placeholder="{{ 'bikeshop.rentals.service_indicators_config.select_linked_product_categories' | translate }}">
                </p-multiSelect>
            </div>
        </div>
    </div>

    <div class="info-container" *ngIf="serviceIndicatorConfig.isActive">

        <!-- BASIC MODE CONFIG -->
        <div *ngIf="serviceIndicatorConfig.mode === 'basic'">
            <div class="row">
                <div class="col-md-12 label header">
                    {{'bikeshop.rentals.service_indicators_config.basic_service_points_configuration' | translate}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 description">
                    <div [ngClass]="{ 'collapsed': !showBasicExpanded, 'expanded': showBasicExpanded }"
                        class="description-expandable">
                        <div
                            innerHTML="{{'bikeshop.rentals.service_indicators_config.basic_configuration_description' | translate}}">
                        </div>
                    </div>
                    <a href="javascript:void(0)" (click)="showBasicExpanded = !showBasicExpanded" class="red">
                        {{ (showBasicExpanded ? 'bikeshop.rentals.service_indicators_config.show_less' :
                        'bikeshop.rentals.service_indicators_config.read_more') | translate }}
                    </a>
                </div>
            </div>

            <div>
                <div class="row margin-top-16">
                    <div class="col-md-6 label">
                        {{'bikeshop.rentals.service_indicators_config.metric' | translate}}:
                    </div>
                    <div class="col-md-6">
                        <p-dropdown [options]="metricOptions" [(ngModel)]="serviceIndicatorConfig.basicIndicator.metric">
                        </p-dropdown>
                    </div>
                </div>

                <div *ngIf="serviceIndicatorConfig.basicIndicator.metric === 'Points'">
                    <div class="row margin-top-16">
                        <div class="col-md-6 label" [ngClass]="{'red': !(serviceIndicatorConfig.basicIndicator.maxPoints > 0)}">
                            {{ 'bikeshop.rentals.service_indicators_config.maximum_service_points' | translate }}:
                        </div>
                        <div class="col-md-6">
                            <input id="maxPoints"                             
                            type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0" 
                            pInputText
                                [(ngModel)]="serviceIndicatorConfig.basicIndicator.maxPoints">
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-6 label" [ngClass]="{'red': serviceIndicatorConfig.basicIndicator.pointsPerRentalPerHour === null || !(serviceIndicatorConfig.basicIndicator.pointsPerRentalPerHour >= 0)}">
                            {{ 'bikeshop.rentals.service_indicators_config.points_per_rental_hour' | translate }}:
                        </div>
                        <div class="col-md-6">
                            <input id="pointsPerRental" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                [(ngModel)]="serviceIndicatorConfig.basicIndicator.pointsPerRentalPerHour">
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-6 label" [ngClass]="{'red': serviceIndicatorConfig.basicIndicator.pointsPerRentalPerDay === null || !(serviceIndicatorConfig.basicIndicator.pointsPerRentalPerDay >= 0)}">
                            {{ 'bikeshop.rentals.service_indicators_config.points_per_rental_day' | translate }}:
                        </div>
                        <div class="col-md-6">
                            <input id="pointsPerRental" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                [(ngModel)]="serviceIndicatorConfig.basicIndicator.pointsPerRentalPerDay">
                        </div>
                    </div>
                    <div class="row margin-top-16">
                        <div class="col-md-6 label" [ngClass]="{'red': serviceIndicatorConfig.basicIndicator.idleDecay === null ||  !(serviceIndicatorConfig.basicIndicator.idleDecay >= 0)}">
                            {{ 'bikeshop.rentals.service_indicators_config.idle_decay' | translate }}:
                        </div>
                        <div class="col-md-6">
                            <input id="idleDecay" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                [(ngModel)]="serviceIndicatorConfig.basicIndicator.idleDecay">
                        </div>
                    </div>
                </div>


                <div class="row margin-top-16" *ngIf="serviceIndicatorConfig.basicIndicator.metric !== 'Points'">
                    <div class="col-md-6 label" [ngClass]="{'red': !(serviceIndicatorConfig.basicIndicator.threshold > 0)}">
                        {{'bikeshop.rentals.service_indicators_config.service_due_at' | translate}}:
                    </div>
                    <div class="col-md-6">
                        <div class="p-inputgroup">
                            <input type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                [(ngModel)]="serviceIndicatorConfig.basicIndicator.threshold" placeholder="{{serviceIndicatorConfig.basicIndicator.metric === 'Mileage' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_distance') : 
                        serviceIndicatorConfig.basicIndicator.metric === 'Hours' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_hours') :
                        serviceIndicatorConfig.basicIndicator.metric === 'TimeIntervalDays' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_days') :
                        serviceIndicatorConfig.basicIndicator.metric === 'RentalCount' ? translate.instant('bikeshop.rentals.service_indicators_config.rental_count') : ''
                        }}">
                            <span class="p-inputgroup-addon">
                                {{serviceIndicatorConfig.basicIndicator.metric === 'Mileage' ?
                                (partnerData.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles') :
                                serviceIndicatorConfig.basicIndicator.metric === 'Hours' ?
                                translate.instant('bikeshop.rentals.booking.hours') :
                                serviceIndicatorConfig.basicIndicator.metric === 'TimeIntervalDays' ?
                                translate.instant('bikeshop.rentals.booking.days') :
                                serviceIndicatorConfig.basicIndicator.metric === 'RentalCount' ?
                                translate.instant('bikeshop.rentals.booking.reservations') : ''
                                }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-6 label">
                    {{'bikeshop.rentals.service_indicators_config.deactivate_when_service_required' | translate}}:
                </div>
                <div class="col-md-6">
                    <p-inputSwitch
                        [(ngModel)]="serviceIndicatorConfig.basicIndicator.deactivateProductWhenServiceRequired"></p-inputSwitch>
                </div>
            </div>
        </div>


        <!-- ADVANCED MODE CONFIG -->
        <div *ngIf="serviceIndicatorConfig.mode === 'advanced'">
            <div class="row">
                <div class="col-md-12 label header" [ngClass]="{'red': serviceIndicatorConfig.advancedIndicators?.length === 0}">{{
                    'bikeshop.rentals.service_indicators_config.advanced_service_indicators' | translate}}</div>
            </div>
            <div class="row">
                <div class="col-md-12 description">
                    <div [ngClass]="{ 'collapsed': !showAdvancedExpanded, 'expanded': showAdvancedExpanded }"
                        class="description-expandable">
                        <div
                            innerHTML="{{'bikeshop.rentals.service_indicators_config.advanced_configuration_description' | translate}}">
                        </div>
                    </div>

                    <a href="javascript:void(0)" (click)="showAdvancedExpanded = !showAdvancedExpanded" class="red">
                        {{ showAdvancedExpanded ? 'Show less' : 'Read more' }}
                    </a>
                </div>
            </div>
            <div class="margin-top-16">
                <div>
                    <p-accordion [activeIndex]="activeIndex">
                        <p-accordionTab
                            *ngFor="let indicator of serviceIndicatorConfig.advancedIndicators; let i = index"
                            [header]="indicator.component || 'New Rule'">
                            <div>

                                <div class="row margin-top-16">
                                    <div class="col-md-6 label">
                                        {{ 'bikeshop.rentals.service_indicators_config.metric' | translate }}:
                                    </div>
                                    <div class="col-md-6">
                                        <p-dropdown [options]="getMetricOptions(indicator)" [(ngModel)]="indicator.metric">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="row margin-top-16">
                                    <div class="col-md-6 label" [ngClass]="{'red': !indicator.component}">
                                        {{ 'bikeshop.rentals.service_indicators_config.component_name' | translate }}:
                                    </div>
                                    <div class="col-md-6">
                                        <input pInputText [(ngModel)]="indicator.component">
                                    </div>
                                </div>

                                <div *ngIf="indicator.metric === 'Points'">
                                    <div class="row margin-top-16">
                                        <div class="col-md-6 label" [ngClass]="{'red': !(indicator.maxPoints > 0)}">
                                            {{ 'bikeshop.rentals.service_indicators_config.maximum_service_points' |
                                            translate }}:
                                        </div>
                                        <div class="col-md-6">
                                            <input id="maxPoints" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                                [(ngModel)]="indicator.maxPoints">
                                        </div>
                                    </div>
                                    <div class="row margin-top-16">
                                        <div class="col-md-6 label" [ngClass]="{'red': indicator.pointsPerRentalPerHour === null || !(indicator.pointsPerRentalPerHour >= 0)}">
                                            {{ 'bikeshop.rentals.service_indicators_config.points_per_rental_hour' |
                                            translate }}:
                                        </div>
                                        <div class="col-md-6">
                                            <input id="pointsPerRental" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                                [(ngModel)]="indicator.pointsPerRentalPerHour">
                                        </div>
                                    </div>
                                    <div class="row margin-top-16">
                                        <div class="col-md-6 label" [ngClass]="{'red': indicator.pointsPerRentalPerDay === null || !(indicator.pointsPerRentalPerDay >= 0)}">
                                            {{ 'bikeshop.rentals.service_indicators_config.points_per_rental_day' |
                                            translate }}:
                                        </div>
                                        <div class="col-md-6">
                                            <input id="pointsPerRental" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                                [(ngModel)]="indicator.pointsPerRentalPerDay">
                                        </div>
                                    </div>
                                    <div class="row margin-top-16">
                                        <div class="col-md-6 label" [ngClass]="{'red': indicator.idleDecay === null || !(indicator.idleDecay >= 0)}">
                                            {{ 'bikeshop.rentals.service_indicators_config.idle_decay' | translate }}:
                                        </div>
                                        <div class="col-md-6">
                                            <input id="idleDecay" type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                                [(ngModel)]="indicator.idleDecay">
                                        </div>
                                    </div>
                                </div>


                                <div class="row margin-top-16" *ngIf="indicator.metric !== 'Points'">
                                    <div class="col-md-6 label" [ngClass]="{'red': !(indicator.threshold > 0)}">
                                        {{ 'bikeshop.rentals.service_indicators_config.service_due_at' | translate }}:
                                    </div>
                                    <div class="col-md-6">
                                        <div class="p-inputgroup">
                                            <input type="number" pattern="[0-9]*" (keypress)="onKeyPress($event)" (paste)="onPaste($event)" step="1" min="0"  pInputText
                                                [(ngModel)]="indicator.threshold" placeholder="{{indicator.metric === 'Mileage' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_distance') : 
                                        indicator.metric === 'Hours' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_hours') :
                                        indicator.metric === 'TimeIntervalDays' ? translate.instant('bikeshop.rentals.service_indicators_config.enter_target_days') :
                                        indicator.metric === 'RentalCount' ? translate.instant('bikeshop.rentals.service_indicators_config.rental_count') : ''
                                        }}">
                                            <span class="p-inputgroup-addon">
                                                {{indicator.metric === 'Mileage' ?
                                                (partnerData.DefaultUnitOfMeasure == 1 ? 'Kms' : 'Miles') :
                                                indicator.metric === 'Hours' ?
                                                translate.instant('bikeshop.rentals.booking.hours') :
                                                indicator.metric === 'TimeIntervalDays' ?
                                                translate.instant('bikeshop.rentals.booking.days') :
                                                indicator.metric === 'RentalCount' ?
                                                translate.instant('bikeshop.rentals.booking.reservations') : ''
                                                }}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                                <div class="row margin-top-16">
                                    <div class="col-md-6 label" [ngClass]="{'red': !indicator.action}">
                                        {{ 'bikeshop.rentals.service_indicators_config.action' | translate }}:
                                    </div>
                                    <div class="col-md-6">
                                        <input pInputText [(ngModel)]="indicator.action" placeholder="{{'bikeshop.rentals.service_indicators_config.action_placeholder' | translate}}">
                                    </div>
                                </div>
                                <div class="row margin-top-16">
                                    <div class="col-md-6 label">
                                        {{ 'bikeshop.rentals.service_indicators_config.deactivate_when_service_required'
                                        | translate }}:
                                    </div>
                                    <div class="col-md-6">
                                        <p-inputSwitch
                                            [(ngModel)]="indicator.deactivateProductWhenServiceRequired"></p-inputSwitch>
                                    </div>
                                </div>
                                <div class="row margin-top-16">
                                    <div class="col-md-8 label">

                                    </div>
                                    <div class="col-md-4">
                                        <button pButton
                                            label="{{'bikeshop.rentals.service_indicators_config.delete_rule' | translate}}"
                                            class="alternate full-width" (click)="removeIndicator(i)"></button>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>
                    </p-accordion>
                    <div class="row margin-top-16">
                        <div class="col-md-4">
                            <button pButton class="full-width"
                                label="{{'bikeshop.rentals.service_indicators_config.add_indicator' | translate}}"
                                (click)="addIndicator()"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="floating-footer">
        <div class="row">
            <div class="col-md-3">
                <button pButton class="full-width alternate" (click)="cancel()" label="{{'general.cancel' | translate}}"
                    [disabled]="saving"></button>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-3">
                <button pButton *ngIf="!saving" class="full-width accent" (click)="saveServiceIndicator()"
                    label="{{'bikeshop.message_templates.save_template' | translate}}" [disabled]="saving || !isValid()"></button>
                <div *ngIf="saving" style="display: flex;justify-content: center;">
                    <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
                    </p-progressSpinner>
                </div>
            </div>
        </div>
    </div>

</div>
<p-confirmDialog></p-confirmDialog>